/**
 * Operator audit log (ported from CC `Audit.tsx` onto the fetch fleet
 * client).
 */
import { useState } from "react";
import {
  Badge, Group, Paper, Stack, Text, TextInput, Title,
} from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { fleetApi } from "../../api/fleet";

export function FleetAuditPage() {
  const [actor, setActor] = useState("");
  const { data, isLoading } = useQuery({
    queryKey: ["fleet", "audit", actor],
    queryFn: () => fleetApi.audit.list({ limit: 200, actor: actor || undefined }),
    refetchInterval: 20_000,
  });

  return (
    <>
      <Group justify="space-between" mb="lg">
        <Title order={2}>Audit Log</Title>
        <TextInput
          placeholder="Filter by actor…"
          value={actor}
          onChange={(e) => setActor(e.currentTarget.value)}
          w={240}
        />
      </Group>
      {isLoading && <Text c="dimmed">Loading…</Text>}
      <Stack gap="xs">
        {data?.map((e) => (
          <Paper key={e.id} p="xs" withBorder>
            <Group justify="space-between">
              <Stack gap={0}>
                <Group gap="xs">
                  <Badge size="xs" variant="light">{e.actor}</Badge>
                  <Text size="sm" fw={500}>{e.action}</Text>
                  {e.resource_type && (
                    <Text size="xs" c="dimmed">{e.resource_type}/{e.resource_id}</Text>
                  )}
                </Group>
                <Text size="xs" c="dimmed">
                  {new Date(e.ts).toLocaleString()}{e.ip ? ` · ${e.ip}` : ""}
                </Text>
              </Stack>
            </Group>
          </Paper>
        ))}
        {!isLoading && !data?.length && <Text c="dimmed">No audit entries.</Text>}
      </Stack>
    </>
  );
}
